import * as React from 'react';
const SvgWindLegend = (props: React.SVGAttributes<SVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="100%" fill="none" viewBox="0 0 315 20" {...props}>
    <rect width={314} height={19} x={0.5} y={0.5} fill="url(#wind_legend_svg__a)" rx={9.5} />
    <rect width={314} height={19} x={0.5} y={0.5} stroke="#6D8B96" rx={9.5} />
    <defs>
      <linearGradient
        id="wind_legend_svg__a"
        x1={0}
        x2={315}
        y1={10}
        y2={10}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#0B0E27" />
        <stop offset={0.036} stopColor="#182F6B" />
        <stop offset={0.071} stopColor="#2755B9" />
        <stop offset={0.094} stopColor="#2D66DC" />
        <stop offset={0.13} stopColor="#52A3AA" />
        <stop offset={0.154} stopColor="#6DCB80" />
        <stop offset={0.181} stopColor="#8BF750" />
        <stop offset={0.214} stopColor="#ADF350" />
        <stop offset={0.242} stopColor="#D0EE4F" />
        <stop offset={0.269} stopColor="#F2E84E" />
        <stop offset={0.29} stopColor="#F4DB49" />
        <stop offset={0.318} stopColor="#EEC343" />
        <stop offset={0.346} stopColor="#E6A83B" />
        <stop offset={0.374} stopColor="#E29637" />
        <stop offset={0.399} stopColor="#E48332" />
        <stop offset={0.425} stopColor="#E57730" />
        <stop offset={0.449} stopColor="#E8692D" />
        <stop offset={0.471} stopColor="#DB5628" />
        <stop offset={0.495} stopColor="#CC4823" />
        <stop offset={0.519} stopColor="#BC391E" />
        <stop offset={0.547} stopColor="#A82618" />
        <stop offset={0.572} stopColor="#9E2116" />
        <stop offset={0.597} stopColor="#921F14" />
        <stop offset={0.626} stopColor="#861D13" />
        <stop offset={0.649} stopColor="#831D19" />
        <stop offset={0.671} stopColor="#852031" />
        <stop offset={0.695} stopColor="#852240" />
        <stop offset={0.72} stopColor="#87255C" />
        <stop offset={0.747} stopColor="#8B266B" />
        <stop offset={0.771} stopColor="#942580" />
        <stop offset={0.798} stopColor="#9A2590" />
        <stop offset={0.823} stopColor="#9F249D" />
        <stop offset={0.846} stopColor="#AF2CB1" />
        <stop offset={0.866} stopColor="#B931BD" />
        <stop offset={0.889} stopColor="#C538CB" />
        <stop offset={0.908} stopColor="#D13ED8" />
        <stop offset={0.927} stopColor="#D85ADE" />
        <stop offset={0.952} stopColor="#DF76E4" />
        <stop offset={0.975} stopColor="#EAA0EC" />
        <stop offset={1} stopColor="#F4C5F4" />
      </linearGradient>
    </defs>
  </svg>
);
export default SvgWindLegend;
